import apiClient from './api';

// Appointment Service
export const appointmentService = {
  // Lấy danh sách appointments
  getAppointments: async (userId, page = 1, limit = 10) => {
    try {
      const response = await apiClient.get(`/appointments?userId=${userId}&page=${page}&limit=${limit}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Tạo appointment mới
  createAppointment: async (appointmentData) => {
    try {
      console.log('appointmentService.createAppointment - sending data:', appointmentData);
      console.log('appointmentService.createAppointment - ScheduledFor value:', appointmentData.ScheduledFor);
      console.log('appointmentService.createAppointment - ScheduledFor type:', typeof appointmentData.ScheduledFor);
      
      const response = await apiClient.post('/appointments', appointmentData);
      console.log('appointmentService.createAppointment - server response:', response.data);
      console.log('appointmentService.createAppointment - server response scheduledFor:', response.data.scheduledFor || response.data.ScheduledFor);
      return response.data;
    } catch (error) {
      console.error('appointmentService.createAppointment - error:', error);
      throw error;
    }
  },

  // Cập nhật appointment
  updateAppointment: async (appointmentId, appointmentData) => {
    try {
      const response = await apiClient.put(`/appointments/${appointmentId}`, appointmentData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Hủy appointment
  cancelAppointment: async (appointmentId) => {
    try {
      // Backend expects POST /Appointments/{id}/cancel
      const response = await apiClient.post(`/appointments/${appointmentId}/cancel`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Lấy chi tiết appointment
  getAppointmentById: async (appointmentId) => {
    try {
      const response = await apiClient.get(`/appointments/${appointmentId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Lấy lịch appointments theo ngày
  getAppointmentsByDate: async (date, therapistId) => {
    try {
      const params = {};
      if (therapistId) params.therapistId = therapistId;
      const response = await apiClient.get(`/appointments/date/${date}`, { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  ,

  // Test connection endpoint
  testConnection: async () => {
    try {
      const response = await apiClient.get('/appointments/test');
      return response.data;
    } catch (error) {
      throw error;
      //
    }
  },

  // Get appointments by date range
  getAppointmentsByDateRange: async (startDate, endDate, therapistId) => {
    try {
      const params = { startDate, endDate };
      if (therapistId) params.therapistId = therapistId;
      const response = await apiClient.get('/appointments/date-range', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get appointments by conversation
  getAppointmentsByConversation: async (conversationId) => {
    try {
      const response = await apiClient.get(`/appointments/conversation/${conversationId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get therapist availability for a specific date
  getTherapistAvailability: async (therapistId, date) => {
    try {
      const response = await apiClient.get(`/appointments/therapist/${therapistId}/availability`, { params: { date } });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};
